import isDashboardSlide from 'screens/WallBoard/isDashboardSlide';
import isDriverLeaderboard from 'screens/WallBoard/isDriverLeaderboard';

const getPrintSlideKind = (
  slide: WallboardSlide | undefined,
): WallboardScreenshots.PrintSlideKind => {
  if (!slide) {
    return 'missing';
  }
  if (isDriverLeaderboard(slide)) {
    return 'leaderboard';
  }
  if (isDashboardSlide(slide)) {
    return 'dashboard';
  }
  return 'weather';
};

export default getPrintSlideKind;
